import type { ProviderManifest } from '../../types';

export const qwenManifest: ProviderManifest = {
  id: 'qwen',
  label: 'Qwen (Alibaba)',
  shortLabel: 'Qwen',
  vendor: 'Alibaba Model Studio (DashScope)',
  capabilities: { tts: true, stt: true },
  // DashScope's realtime WebSocket APIs authenticate with an Authorization
  // header, which the browser WebSocket constructor cannot set — so this
  // provider talks to the REST endpoints instead. See docs/providers/qwen.md.
  transport: { tts: 'rest-blob', stt: 'rest-batch' },
  // Deliberately claiming every language: the vendor documents English and
  // Chinese for TTS (plus Hindi for ASR), but the POC exists to find out what
  // actually happens with the rest, so resolution must not silently divert to
  // another provider. The client emits a warning for undocumented languages.
  languages: { tts: null, stt: null },
  exposesKeyToClient: true,
  experimental: true,
  notes:
    'Runs entirely in the browser, so the API key is exposed — internal POC only. '
    + 'Vendor documents English + Chinese for TTS (plus Hindi for ASR); other languages '
    + 'are untested. No live transcript: speech is transcribed after you stop recording.',
};
